<template>
  <v-card fill-height>
    <v-layout row wrap justify-center>
      <v-layout>
        <StrukturBilanzTable :hasAmpel="true" :sortDisabled="true"  :heightSub="tableHeightSub"
                             ref="kdfTable"
                             tableName=""
                             edoClassName="kz"></StrukturBilanzTable>
        <!--
        <v-container class="pt-0 ml-1">

          <table class="colorrows" style="border-collapse: collapse !important;">
            <tr>
              <th style="background-color: white" colspan="2"> &nbsp;</th>
            </tr>
            <tr v-for="row in rows">
              <td v-for="cell in row.cells" style="text-align: left;width:50%; height: 30px;">
                <v-layout v-if="cell.index == 0">
                  <v-flex xs12 class="px-4">
                    <span style="float:left;" v-if="cell && cell.prefix">{{cell.prefix}}</span>
                    <span :style="getStyle(row, cell)" v-if="cell && (!cell.display)">{{getTitle(cell)}}</span>
                  </v-flex>
                </v-layout>
                <v-layout v-if="cell.index == 1">
                  <v-flex xs6 class="px-2" v-if="cell && cell.display">
                    <span style="float:left;" v-if="cell && cell.prefix">{{cell.prefix}}</span>
                    <span :style="getStyle(row, cell)" v-if="cell && (!cell.display)">{{getTitle(cell)}}</span>
                    <v-spacer></v-spacer>
                  </v-flex>
                  <v-flex xs6 class="px-4" v-if="cell && cell.display">
                    <Ampel style="float:right;" v-if="cell && cell.display && cell.display === 'ampel3'" :cnt="3"
                           :state="cell.co"></Ampel>
                    <Ampel style="float:right;" v-if="cell && cell.display && cell.display === 'ampel2'" :cnt="2"
                           :state="cell.co"></Ampel>
                  </v-flex>
                  <v-flex xs12 class="px-4" v-if="!(cell && cell.display)">
                    <span style="float:left;" v-if="cell && cell.prefix">{{cell.prefix}}</span>
                    <span :style="getStyle(row, cell)" v-if="cell && (!cell.display)">{{getTitle(cell)}}</span>
                  </v-flex>
                </v-layout>

              </td>
            </tr>
          </table>
        </v-container>
        -->
      </v-layout>

    </v-layout>
  </v-card>
</template>
<script>
import Vue from 'vue'
import StrukturBilanzTable from './StrukturBilanzTable'
import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'
import Ampel from './../../widgets/TrafficLight'

export default {
  name: 'TabKDF',
  components: {Ampel, StrukturBilanzTable, BtnDownloadExcel},
  props: ['balance'],
  methods: {
    open: function () {
      Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
      this.reload()
    },
    close: function () {
    },
    getTitle: function (cell) {
      var value = cell.co
      if (cell.format) {
        return Vue.prototype.$api.convertToWaimeaDecimal(cell.format, value)
      }
      return value
    },
    getStyle: function (row, cell) {
      var css = 'float:left;'
      if (cell.index === '1') {
        css = 'float:right;'
      }
      if (!cell) return css
      if (row.fontBold === 1) {
        css += 'font-weight:bold;'
      }
      return css
    },
    onGetData: function (data) {
      Vue.prototype.$api.debug('Kennzahlen', data)
      delete(data.tables)
      this.tableData = data
      if (this.$refs['kdfTable'] && this.$refs['kdfTable'].open) {
        Vue.prototype.$api.debug('open', this.tableData)
        this.$refs['kdfTable'].open(this.tableData)
      }
      Vue.prototype.$api.hideIdle()
    },
    reload: function () {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getKDFDataWithBalance(this.balance, this.onGetData)
    }
  },
  data () {
    return {
      rows: [],
      configExcel: {
        excelSheetStammdaten: 0,
        excelSheetStrukturbilanz: 0,
        excelSheetRohbilanz: 0,
        excelSheetKennzahlen: 0,
        excelSheetBilanzrating: 0,
        excelSheetKDF: 1,
        configName: '',
        btnName: Vue.i18n.translate('DOWNLOAD_NAME_KDF'),
        type: 'EXCEL-STRUCT'
      },
      tableData: null,
      tableHeightSub: 110
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabKDF.vue